<div class="component-card m-0">
    <div style="display: inline-block;width: 100%;">
        <h1 class="component-title">{{'Payment'|translate}} / <span>{{'Processed'|translate}}</span></h1>
        <i class="pi pi-ellipsis-v spam-menu"></i>
    </div>
    <div class="panel_wrapper">
        <div class="d-flex flex-row justify-content-between pb-4">
            <div class="p-inputgroup div_search_field w-75">
                <button type="button" class="search_btn_icon"><i class="pi pi-search"></i></button>
                <input type="text" class="input_text_search_field" placeholder="Search...">
                <button type="button" class="search_btn_icon"><i class="pi pi-times"></i></button>
            </div>
            <p-dropdown class="src_dropdown" [options]="src_drop_opt" [(ngModel)]="selected_drop_opt" optionLabel="name"
                optionValue="id"></p-dropdown>
            <p-calendar class="search_date_picker" dateFormat="dd/mm/yy" placeholder="Date..." [showIcon]="true">
            </p-calendar>
            <div class="p-inputgroup div_search_field ps-3 w-50">
                <input type="text" class="input_text_search_field" placeholder="Location...">
                <button type="button" class="search_btn_icon"><i class="pi pi-times"></i></button>
            </div>
        </div>
    </div>
</div>

<p-tabView class="payment-tabs">
    <p-tabPanel>
        <ng-template pTemplate="header">
            <label class="w-100 text-centar">PROCESSED <span class="color_mono_txt">(78)</span></label>
        </ng-template>
        <div>
            <ng-container *ngTemplateOutlet="paymentTemplate"></ng-container>
        </div>
    </p-tabPanel>
    <p-tabPanel>
        <ng-template pTemplate="header">
            <label class="w-100 text-centar">OVERDUE <span class="color_mono_txt">(8)</span></label>
        </ng-template>
        <div>
            <ng-container *ngTemplateOutlet="paymentTemplate"></ng-container>
        </div>
    </p-tabPanel>
    <p-tabPanel>
        <ng-template pTemplate="header">
            <label class="w-100 text-centar">INVOICES <span class="color_mono_txt">(12)</span></label>
        </ng-template>
        <div>
            <ng-container *ngTemplateOutlet="paymentTemplate"></ng-container>
        </div>
    </p-tabPanel>
    <p-tabPanel>
        <ng-template pTemplate="header">
            <label class="w-100 text-centar ">ARCHIVE <span class="color_mono_txt"></span></label>
        </ng-template>
        <div>
            <ng-container *ngTemplateOutlet="paymentTemplate"></ng-container>
        </div>
    </p-tabPanel>
</p-tabView>


<ng-template #paymentTemplate>
    <div style="padding-right: 4px; height: 430px;overflow-y: auto;overflow-x: hidden;" infiniteScroll
        [infiniteScrollDistance]="2" [infiniteScrollUpDistance]="1000" (scrolled)="loadMorePayments()"
        [scrollWindow]="false">
        <div *ngFor="let payment of paymentList" class="component-card">
            <div class="component-list-card">
                <div class="d-flex flex-row justify-content-between">
                    <div class="d-flex flex-row me-3" style="align-items: self-end;">
                        <img class="payment_picture_list" [src]="payment.CompanyImagePath" alt="profile-picture">
                        <div class="company_info ">
                            <h5 class="title">{{payment.CompanyName}}</h5>
                            <div class="payment_company">
                                <span> {{payment.CompanyWebSite}} </span>
                            </div>
                        </div>
                    </div>
                    <div class="div_group_payment">
                        <div class="div_lbl_group">
                            <label class="lbl_color_list">{{ 'PROCESS DATA' | translate }}</label>
                            <label class="lbl_list">{{ payment.ProcessDataName }}</label>
                            <label class="lbl_list_date">{{ payment.PaymentDate }}</label>
                        </div>
                        <div class="div_lbl_group">
                            <label class="lbl_color_list">{{ 'INSTALLMENT' | translate }}</label>
                            <label class="lbl_list">{{ payment.InstallmentName }}<span> |
                                    {{payment.InstallmentPrice}}</span></label>
                            <label class="lbl_list_price">{{ payment.PaymentPrice }}</label>
                        </div>
                    </div>
                    <div class="ms-2" style="max-width: 140px;">
                        <button class=" btn_without_color btn_border_color w-100 mb-2"
                            (click)="detailsPayment(payment.Id)">{{ 'Details' | translate}}</button>
                        <button class="btn_in_color  w-100" (click)="archivePayment(payment.Id)">{{ 'Archive' |
                            translate}}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>